import api from "../../Http/global-vars";
import { FETCH_NOTIFICATIONS } from "../types";

export const fetchNotifUser = (id) => {
  return async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem("userToken")}`,
      },
    };
    const url = api + "notificationbyuser/" + id + "/";
    
    await fetch(url, config)
      .then(async (res) => {
        const data = await res.json();
        // console.log("data categories", data)
        dispatch({
          type: FETCH_NOTIFICATIONS,
          payload: data
            .filter((item) => item?.read === false)
            .sort((a, b) => b?.id - a?.id),
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
